import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { baseUrl } from '../../config/route-entry-point';

import ComplaintForm from './complaint-form';
import Avatar from './avatar';

lessRequire('modules/shared/manager.less');

const isEverad = process.env.CPA_ENV === 'everad';

const volatiles = {
	telegram: isEverad ? 'Everad_Support' : 'Daraibova',
	vk: isEverad ? 'everad_cpa' : 'rocketprofit'
};

export default class Manager extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { data, user, intl } = this.props;
		const telegram = data.telegram || volatiles.telegram;

		return (
			<div className="manager">
				<div className="online">
					<div>
						<div />
					</div>
				</div>

				{
					data.avatar ?
						<Avatar className="manager__avatar" src={data.avatar} /> :
						<div className="manager__avatar">
							<span className="default-support-avatar" />
						</div>
				}

				<div className="manager__info">
					<p className="manager__info-name font-proxima-nova-bold">{data.name}</p>
					<p className="manager__info-time">{intl(
						isEverad ? 'С 10:00 до 19:00 по Киеву' : 'С 10:00 до 19:00 по МСК'
					)}</p>
				</div>

				<div className="manager__contacts clearfix">
					<div className="table">
						{data.skype && (
							<div className="td">
								<div className="manager__contacts-block">
									<p>Skype</p>
									<span className="font-proxima-nova-semibold">
										<a href="skype:data.skype">{data.skype}</a>
									</span>
								</div>
							</div>
						)}
						<div className="td">
							<div className="manager__contacts-block">
								<p>Telegram</p>
								<span className="font-proxima-nova-semibold">
									<a
										href={`https://telegram.me/${telegram}`}
										target="_blank"
									>
										{`@${telegram}`}
									</a>
								</span>
							</div>
						</div>
						<div className="td">
							<div className="manager__contacts-block">
								<p>VK</p>
								<span className="font-proxima-nova-semibold">
									<a href={`https://vk.com/${volatiles.vk}`} target="_blank">
										{volatiles.vk}
									</a>
								</span>
							</div>
						</div>
					</div>
				</div>

				<Link to={baseUrl(`tickets/`)} className="button yellow-btn font-proxima-nova-semibold">
					{intl('Задать вопрос менеджеру')}
				</Link>

				<p className="manager__remarks">
					{intl('Если у вас есть замечания по работе')}&nbsp;
					{intl('менеджера, пожалуйста,')}{' '}
					<a
						href="#"
						onClick={e => {
							e.preventDefault();
							this.form.toggleModal();
						}}
					>
						{intl('напишите нам')}
					</a>
				</p>

				<ComplaintForm user={user} intl={intl} ref={form => (this.form = form)} />
			</div>
		);
	}
}

Manager.propTypes = {
	data: PropTypes.object,
	user: PropTypes.object,
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/manager.js